import { useState } from "react";
import RBACService from "../services/api";

export const useRBAC = () => {
    const [isLoadingGetProfilePermissions, setIsLoadingGetProfilePermissions] = useState(false)
    const [isDoneGetProfilePermissions, setIsDoneGetProfilePermissions] = useState(false)
    const [profilePermissions, setProfilePermissions] = useState([])
    const [errorGetProfilePermissions, setErrorGetProfilePermissions] = useState(null)
    const [rolesList, setRolesList] = useState([])

    const getProfilePermissions = (profile_uid) => {
        setIsLoadingGetProfilePermissions(true)
        setErrorGetProfilePermissions(null)
        setProfilePermissions([])
        setIsDoneGetProfilePermissions(false)
        RBACService.getProfilePermissions(profile_uid).then((res) => {
            setIsLoadingGetProfilePermissions(false)
            setProfilePermissions(res.data.data)
            setIsDoneGetProfilePermissions(true)
        })
        .catch((e) => {
            setIsLoadingGetProfilePermissions(false)
            setErrorGetProfilePermissions(e.response?.data)
            setProfilePermissions([])
            setIsDoneGetProfilePermissions(true)
        })
    }

    const getRoleByProfileType = (parameters) => {

        RBACService.getRoleByProfileType(parameters).then((res) => {
            console.log("getRoleByProfileType res", res)
            setRolesList(res.data.data)
        })
        .catch((e) => {
            console.log("getRoleByProfileType error", e)
        })
    }

    return {
        isLoadingGetProfilePermissions, 
        isDoneGetProfilePermissions,
        profilePermissions, 
        errorGetProfilePermissions,
        getProfilePermissions, 

        getRoleByProfileType,
        rolesList
    }
}
